import { Plugin } from '@tiptap/pm/state';
import { isObject, isString } from 'lodash';

/**
 * Tiptap suffixes the keys with a number to indentify the number of the instance,
 * so we are using `startWith` to check if the name matches.
 */
export function createPluginKeyChecker(key: string) {
  return (plugin: Plugin) =>
    isObject(plugin.spec.key) &&
    'key' in plugin.spec.key &&
    isString(plugin.spec.key['key']) &&
    plugin.spec.key['key'].startsWith(key);
}
